import { ToastMessage } from "flavr-common";
import { scriptService } from "../services/ScriptService";
export class ScriptToast {
    static message(text, type) {
        if (!scriptService.context)
            return;
        scriptService.context.connection.send(new ToastMessage(text, type));
    }
}
